<template>
  <reach-input
      label="TAX ID"
      :formField="validatedField"
      :read-only="readOnly"
  >
    <template slot="right-slot">
      <b-button style="height: 38px" @click="lodaDataFromGus" class="input-group-text solid"
                v-if="!readOnly" :disabled="mode=='NEW'" data-test-path="getDataFromGus">
        <font-awesome-icon icon="cloud-arrow-down"/>
      </b-button>
    </template>

  </reach-input>

</template>

<script>

import InputBase from "@/components/inputs/InputBase";
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import DialogManager from "@/utils/DialogManager";
import SupplierService from "@/server/com/silkplm/rpc/plm/services/SupplierService";
import {deleteAsStream} from "@/components/forms/customizations/plm/EntitiesListService";


export default {
  name: "DataFromGusRenderer",
  components: {InputBase, ReachInput},
  created() {
  },

  async mounted() {
    this.form = this.validatedField.getFormConfig();
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    mode: {type: String, default: "NEW"},
    fieldConfig: {type: TextFormFieldConfig, required: true},
    entityId: {type: String, default: ""},
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    async lodaDataFromGus() {
      let inputValue = this.validatedField.validatedForm.originalSource.taxID;
      let eid = this.validatedField.validatedForm.originalSource.EID;
      let clazz = this.form.formClassLong;
      if (eid === "") {
        await DialogManager.info(" ", $tr('dataFromGusRenderer.new.contractor','For a new contractor, you cannot download data from CEIDG.' +
            '<br /> Please save the contractor and try again.'));
      }
      else if (inputValue.length === 10) {
        if (await DialogManager.yesNo($tr('information','Information'),
            $tr('dataFromGusRenderer.long.massage','If you changed something in the form, save it before retrieving data from CEIDG. <br /> ' +
                'Are you sure you want to download the data from CEIDG?'), false)) {
          try {
            await Rpc.plm.services.SupplierService.replaceDataWithDataFromCEIDGByTaxId(inputValue, clazz, eid)
          } catch (e) {
            await DialogManager.info($tr('unableToDownloadData','Unable to download data'),
                $tr('incorrectTaxIdEntered','Incorrect Tax ID entered'));
          }
        }
      } else {
        await DialogManager.info($tr('dataFromGus.error','Error'), $tr('dataFromGusRenderer.correct.tax','Please correct the Tax Id and try again.'));
      }
    },
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    form: null,
  })
}

</script>

<style scoped>

</style>